import { takeEvery } from 'redux-saga/effects';

import * as bookingCardActions from 'store/modules/bookingCard';

import { rejectBooking } from './utils';

export default function* listenReject() {
  yield takeEvery(bookingCardActions.reject, rejectBooking);
}
